export const additionalLinkTypes = [
    {
        name: 'X / Twitter',
        value: 'X / Twitter',
    },
    {
        name: 'Website',
        value: 'Website',
    },
    {
        name: 'YouTube',
        value: 'YouTube',
    },
    {
        name: 'Facebook',
        value: 'Facebook',
    },
]

export const linkTypes = [
    {
        name: 'LinkedIn',
        value: 'LinkedIn',
    },
    {
        name: 'GitHub',
        value: 'GitHub',
    },
    {
        name: 'Instagram',
        value: 'Instagram',
    },
    ...additionalLinkTypes,
]
